import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    OperatingHours, OperationalDays,
} from 'app/enums/label.enums'
import {
    WorkSchedule,
} from '../Gateways.types'

export default ({
    isAllDay,
    getAllowedValues,
}: {
    isAllDay: boolean,
    getAllowedValues: (val: Record<string, string>) => Record<string, string>
}): DTOCardFormField<keyof WorkSchedule>[] => {
    return [{
        id: 'workSchedule',
        title: 'Settings',
        fields: [
            {
                name: 'operatingDays',
                labelKey: 'ServiceCenter.operationalDays',
                componentName: 'EnumSelector',
                className: 'operatingDays',
                useDropdown: true,
                allowedValues: getAllowedValues(OperationalDays),
                required: true,
            },
            {
                name: 'operatingHours',
                labelKey: 'WorkSchedule.operatingHours',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(OperatingHours),
                required: true,
            },
            {
                name: 'workStartsAt',
                labelKey: 'WorkSchedule.workStartsAt',
                componentName: 'TimePicker',
                disabled: isAllDay,
                defaultValue: isAllDay ? '00:00' : undefined,
                required: true,
            },
            {
                name: 'workEndsAt',
                labelKey: 'WorkSchedule.workEndsAt',
                componentName: 'TimePicker',
                disabled: isAllDay,
                defaultValue: isAllDay ? '23:59' : undefined,
                required: true,
            },
        ],
    }]
}
